import { render, staticRenderFns } from "./classSure.vue?vue&type=template&id=2774d013&scoped=true"
import script from "./classSure.vue?vue&type=script&lang=js"
export * from "./classSure.vue?vue&type=script&lang=js"
import style0 from "./classSure.vue?vue&type=style&index=0&id=2774d013&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774d013",
  null
  
)

export default component.exports